module.exports = __webpack_public_path__ + "img/20180815_150347_086.9bf1d2dd.jpg";